import { render, staticRenderFns } from "./fido2Keys.vue?vue&type=template&id=000a4527&scoped=true&"
import script from "./fido2Keys.vue?vue&type=script&lang=js&"
export * from "./fido2Keys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a4527",
  null
  
)

export default component.exports